/* eslint-disable */
/**
 * SDK entry (general purpose).
 * Exposes:
 *   - window.Analytics (constructor)
 *   - window.AnalyticsCollector.init(config) — convenience bootstrapper
 */
require('./analytics.js');

(function (global) {
  if (!global) return;

  function init(config) {
    if (global.AnalyticsCollector && global.AnalyticsCollector._instance) {
      return global.AnalyticsCollector._instance;
    }
    var Ctor = global.Analytics;
    if (typeof Ctor !== 'function') {
      throw new Error('[AnalyticsCollector] Analytics class is not loaded');
    }
    var inst = new Ctor(config || {});
    if (config && config.autoPageView !== false) {
      try {
        inst.pageView();
      } catch (e) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[AnalyticsCollector] auto pageView failed', e);
        }
      }
      // S3: SPA 라우트 변경 시에도 page_view 재발화(App Router 등). autoPageView 켜진 경우만.
      try {
        if (typeof inst._startSpaPageViewTracking === 'function') {
          inst._startSpaPageViewTracking();
        }
      } catch (e) { /* ignore */ }
    }
    if (!global.AnalyticsCollector) global.AnalyticsCollector = {};
    global.AnalyticsCollector._instance = inst;
    return inst;
  }

  global.AnalyticsCollector = global.AnalyticsCollector || {};
  global.AnalyticsCollector.init = init;
  global.AnalyticsCollector.get = function () {
    return global.AnalyticsCollector._instance || null;
  };
})(typeof window !== 'undefined' ? window : null);
